import appConfig from "@/config/app-config";
import packageJson from "../../package.json";
import { FormattedAnswer } from "@/data/onboarding/types";

export function ping() {
  return fetch(`${appConfig.apiBase}/healthping`);
}

export const challenge = async (): Promise<Response> => {
  const challengeRequest = {
    method: "bankid",
  };

  return fetch(`${appConfig.apiBase}/auth/challenge`, {
    method: "POST",
    body: JSON.stringify(challengeRequest),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const completeLogin = async (
  challengeToken: string,
): Promise<Response> => {
  const loginRequest = {
    challengeToken,
    method: "bankid",
  };

  return fetch(`${appConfig.apiBase}/auth/login`, {
    method: "POST",
    body: JSON.stringify(loginRequest),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Token ${challengeToken}`,
    },
  });
};

export const loginWithCredentials = async (
  personalNumber: string,
  treatmentArea: string,
  answers: FormattedAnswer[],
  sourceParams?: Record<string, string> | null,
  referrer?: string | null,
): Promise<Response> => {
  const request = {
    identifier: personalNumber?.replace("-", ""),
    treatmentArea,
    answers,
    sourceParams,
    referrer,
  };

  return fetch(`${appConfig.apiBase}/auth/login/webreg/test`, {
    method: "POST",
    body: JSON.stringify(request),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const beginLoginFlow = async (
  submission: WebOnboardingRegistrationSubmission,
): Promise<SecureStartResponse> => {
  return new Promise((resolve, reject) => {
    fetch(`${appConfig.apiBase}/auth/login/webreg`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(submission),
    })
      .then(
        (res) => {
          if (res.ok) {
            return res.json();
          }

          reject(new Error("Something went wrong"));
        },
        (err: Error) => reject(err),
      )
      .then(
        (json) => {
          resolve(json as SecureStartResponse);
        },
        (err: Error) => reject(err),
      );
  });
};

export const getSession = async (
  sessionId: string,
  signal?: AbortSignal,
): Promise<Response> => {
  return fetch(`${appConfig.apiBase}/auth/login/webreg/${sessionId}`, {
    signal,
  });
};

export const saveEmail = async (
  email: string,
  listId: string,
): Promise<Response> => {
  return fetch(`${appConfig.apiBase}/public/mailchimp/subscribe`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, listId }),
  });
};

export const getLabellingInfo = async (): Promise<Response> => {
  return fetch(
    `${appConfig.apiBase}/friska/version/web_onboarding/${packageJson.version}`
  );
};
